export function initLoadMoreArticles() {
  (function ($) {
    let currentPage = 1;
    let currentCategory = "all";
    const $grid = $("#blog-grid");
    const $wrapper = $("#load-more-wrapper");
    let $button = $("#load-more");

    // === Load More Click ===
    $wrapper.on("click", "#load-more", function () {
      currentPage++;
      fetchArticles(currentPage, currentCategory, false);
    });

    // === Category Filter Click ===
    $(document).on("click", "[data-category]", function () {
      currentCategory = $(this).data("category");
      currentPage = 1;

      $("[data-category]").removeClass("bg-primary text-white");
      $(this).addClass("bg-primary text-white");

      $wrapper.html(`
        <button id="load-more" class="px-8 py-3 bg-primary text-white rounded-lg hover:bg-primary/80 transition">
          Load More Articles
        </button>
      `);
      $button = $("#load-more");

      fetchArticles(currentPage, currentCategory, true);
    });

    // === AJAX Function ===
    function fetchArticles(page, category, replace) {
      $.ajax({
        url: ducon_ajax.ajax_url,
        type: "POST",
        data: {
          action: "load_more_articles",
          page,
          category,
        },
        beforeSend: function () {
          $button.prop("disabled", true).text("Loading...");
        },
        success: function (response) {
          if (response.success && response.data.content.trim() !== "") {
            if (replace) {
              $grid.hide().html(response.data.content).fadeIn(300);
            } else {
              const $newPosts = $(response.data.content).hide();
              $grid.append($newPosts);
              $newPosts.fadeIn(300);
            }

            $button.prop("disabled", false).text("Load More Articles");

            if (page >= response.data.max) {
              $wrapper.html(
                '<p class="text-gray-600 text-lg font-medium mt-6">🎉 No more blogs to show.</p>'
              );
            }
          } else {
            if (replace) {
              $grid.html(
                '<p class="col-span-full text-center text-gray-600 text-lg font-medium py-8">No Blogs to show.</p>'
              );
              $wrapper.empty();
            } else {
              $wrapper.html(
                '<p class="text-gray-600 text-lg font-medium mt-6">🎉 No more blogs to show.</p>'
              );
            }
          }
        },
        error: function () {
          $wrapper.html(
            '<p class="text-red-500 text-lg font-medium mt-6">⚠ Error loading posts.</p>'
          );
        },
      });
    }
  })(jQuery);
}
